import enLang from './entries/en-US';
import viLang from './entries/vi_VN';
import laLang from './entries/la_LA';

const AppLocale: any = {
  en: enLang,
  vi: viLang,
  la: laLang,
};

export default AppLocale;
